import type {Instant, UUID} from './common'
import type {TerminationAction} from './system'


export interface System {
    id: UUID
    systemType: string
    environment: string
    name: string
    authoritativeForIdentities: boolean
    authoritativeForAttributes: boolean
    authoritativeForAccounts: boolean
    terminationAction: 'DELETE' | 'DISABLE'
    version: number
    createdAt: Instant
    updatedAt: Instant
}

export interface UpdateTerminationActionRequest {
    terminationAction: TerminationAction
}

/* eslint-disable i18next/no-literal-string -- field name constants for backend API */
export const TargetSystemResponseFields = {
    id: 'id',
    systemType: 'systemType',
    environment: 'environment',
    name: 'name',
    description: 'description',
    externalId: 'externalId',
    authoritativeForIdentities: 'authoritativeForIdentities',
    authoritativeForAttributes: 'authoritativeForAttributes',
    authoritativeForAccounts: 'authoritativeForAccounts',
    terminationAction: 'terminationAction',
    version: 'version',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
} as const

export const UpdateAccountRequestFields = {
    externalIdentifier: 'externalIdentifier',
    version: 'version',
} as const
/* eslint-enable i18next/no-literal-string */
